import React from 'react';

import { useToasts } from 'react-toast-notifications';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import { personRoles } from '@models/PotModel/personRoles';

import css from './CustomUpload.module.scss';

type CustomUploadProps = {
    inputName: string;
    format: string;
    fileSizeLimit: number;
    fileWidthLimit: number;
    fileHeightLimit: number;
    children: React.ReactNode;
    onActiveUpload: boolean;
    onUploadImg: (any) => void;
    personRole?: string;
};

const CustomUpload = ({
    inputName,
    format,
    onUploadImg,
    fileSizeLimit,
    fileWidthLimit,
    fileHeightLimit,
    children,
    personRole,
    onActiveUpload,
}: CustomUploadProps) => {
    const { t } = useTranslateLpc('common');
    const { addToast } = useToasts();
    const onChange = (e) => {
        if (personRole !== personRoles.ORGANISER) {
            return;
        }

        e.preventDefault();
        if (!e || !e.target || !e.target.files || !e.target.files.length) {
            return;
        }
        const file = e.target.files[0];

        if (file.size > fileSizeLimit) {
            addToast(t(`errors.WRONG_SIZE_IMG`), {
                appearance: 'error',
                autoDismiss: true,
            });

            return;
        }

        const getImageDimension = (image) => {
            return new Promise((resolve, reject) => {
                try {
                    const fileReader = new FileReader();

                    fileReader.onload = () => {
                        const img = new Image();
                        img.onload = () => {
                            resolve({ width: img.width, height: img.height });
                        };
                        if (typeof fileReader.result === 'string') {
                            img.src = fileReader.result;
                        }
                    };

                    fileReader.readAsDataURL(image);
                } catch (e) {
                    reject(e);
                }
            });
        };

        getImageDimension(file).then((res) => {
            // @ts-ignore
            if (res.width > fileWidthLimit || res.height > fileHeightLimit) {
                return;
            }
            return onSubmit();
        });

        const onSubmit = () => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            return (reader.onload = () => {
                const body = { image: reader.result };
                return onUploadImg(body);
            });
        };
    };

    return (
        <label>
            {children}
            <input
                className={css.hidden}
                type={onActiveUpload ? 'file' : ''}
                onChange={(e) => onChange(e)}
                name={inputName}
                accept={format}
            />
        </label>
    );
};
export default CustomUpload;
